var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:litecoin",
    clipPath: "url(#clip0_521_174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.125 0.666748C29.0049 0.666748 22.0447 2.77811 16.1245 6.73384C10.2043 10.6896 5.59011 16.312 2.86535 22.8901C0.140598 29.4683 -0.572322 36.7067 0.816746 43.69C2.20581 50.6733 5.63448 57.0879 10.6692 62.1226C15.7039 67.1573 22.1185 70.586 29.1018 71.975C36.0851 73.3641 43.3235 72.6512 49.9016 69.9264C56.4798 67.2017 62.1022 62.5875 66.0579 56.6673C70.0136 50.7471 72.125 43.7869 72.125 36.6668C72.125 27.119 68.3322 17.9622 61.5809 11.2109C54.8296 4.45959 45.6728 0.666748 36.125 0.666748ZM35.339 11.7007H43.091C43.2496 11.7009 43.406 11.7378 43.548 11.8084C43.6899 11.879 43.8137 11.9815 43.9095 12.1078C44.0054 12.2342 44.0707 12.3809 44.1005 12.5367C44.1302 12.6925 44.1236 12.853 44.081 13.0057L37.991 33.7598L43.706 32.0138L42.482 36.1688L36.71 37.8488L32.966 50.4908H52.994C53.1528 50.4916 53.3091 50.5292 53.4509 50.6005C53.5927 50.6719 53.7161 50.7751 53.8114 50.902C53.9067 51.029 53.9713 51.1763 54.0002 51.3324C54.0291 51.4884 54.0215 51.6491 53.978 51.8018L52.232 57.8018C52.1484 58.0872 51.9747 58.3379 51.7367 58.5164C51.4988 58.6948 51.2094 58.7914 50.912 58.7918H20.324L25.493 41.3258L19.775 43.0658L21.035 38.9828L26.765 37.2428L34.031 12.7027C34.1107 12.4158 34.2818 12.1627 34.5184 11.9818C34.7551 11.801 35.0442 11.7023 35.342 11.7007H35.339Z",
    fill: "#9EEFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.125 0.666748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.172084771852cda05f043f5d5a00c6f5.svg";
export { ForwardRef as ReactComponent };